/* ── Sound Machine — Included Sounds Grid — Audio Player ─────────────────── */
(function () {
  'use strict';

  const player  = document.getElementById('so-sg-audio');
  const circles = document.querySelectorAll('.so-sound-circle[data-preview]');
  const nowBar  = document.querySelector('.so-sounds-now-playing');
  const nowTitle= nowBar ? nowBar.querySelector('.so-sounds-now-playing__title') : null;
  const stopBtn = nowBar ? nowBar.querySelector('.so-sounds-now-playing__stop') : null;

  if (!player || !circles.length) return;

  let activeCircle = null;

  function stopAll() {
    player.pause();
    player.src = '';
    clearTimeout(player._soTimer);
    if (activeCircle) {
      activeCircle.classList.remove('is-playing');
      activeCircle.querySelector('.so-sound-circle__play-icon').textContent = '▶';
      activeCircle = null;
    }
    if (nowBar) nowBar.classList.remove('is-visible');
  }

  function play(circle) {
    const url   = circle.dataset.preview;
    const name  = circle.dataset.name || 'Playing preview...';
    if (!url) return;

    if (activeCircle === circle && !player.paused) { stopAll(); return; }
    if (activeCircle) stopAll();

    player.src = url;
    player.currentTime = 0;
    player.play().catch(function(){});

    activeCircle = circle;
    circle.classList.add('is-playing');
    circle.querySelector('.so-sound-circle__play-icon').textContent = '⏹';

    if (nowBar && nowTitle) {
      nowTitle.textContent = name;
      nowBar.classList.add('is-visible');
    }

    player._soTimer = setTimeout(stopAll, 30000);
  }

  circles.forEach(function(c) {
    c.addEventListener('click', function(e) {
      e.preventDefault();
      play(c);
    });
  });

  if (stopBtn) stopBtn.addEventListener('click', stopAll);

  player.addEventListener('ended', stopAll);
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden') stopAll();
  });
})();